// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6f8b3d5e] .avue-crud__pagination .el-pagination{display:inline-block!important}[data-v-6f8b3d5e] .el-dialog__header{border-bottom:1px solid #ebebeb;padding-bottom:15px}[data-v-6f8b3d5e] .el-dialog__body{padding:0}[data-v-6f8b3d5e] .el-table td .is-left{padding-left:20px}[data-v-6f8b3d5e] .el-select{width:100%}[data-v-6f8b3d5e] .el-drawer__header{border-bottom:1px solid #ebebeb;padding:10px 20px;margin-bottom:0}[data-v-6f8b3d5e] .el-drawer__body{padding:0}", ""]);
// Exports
module.exports = exports;
